import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{yield}}",{ moduleName: "seshy/components/gravatar-image.hbs" })